module.exports = __webpack_public_path__ + "static/media/bulbul.32796f49.jpeg";